import { Container, enums } from 'edrolo-ui';
import { useAnalytics } from 'edrolo/analytics';
import s from './styles.scss';

export const Footer = () => {
  const now = new Date();
  const { track } = useAnalytics({});

  return (
    <footer className={s.footer}>
      <Container width={enums.Width.WIDE}>
        <div className={s.inner}>
          <nav>
            <ul>
              <li>
                <a onClick={() => track('footer home link clicked')} href="/">
                  Home
                </a>
              </li>
              <li>
                <a
                  onClick={() => track('footer contact us link clicked')}
                  href="/contact/"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  onClick={() => track('footer jobs link clicked')}
                  href="/jobs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Jobs
                </a>
              </li>
              <li>
                <a
                  onClick={() =>
                    track('footer terms and conditions link clicked')
                  }
                  href="/terms/"
                >
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a
                  onClick={() => track('footer privacy policy link clicked')}
                  href="/privacy/"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </nav>

          <span>&copy; Edrolo {now.getFullYear()}</span>
        </div>
      </Container>
    </footer>
  );
};
